<template>
  <div
    class="g-timeline__page"
    style="width: 100%; height: 100%; display: flex"
  >
    <input type="file" accept=".json" style="display: none" id="loadSetup" />

    <modal
      name="saveConfigModal"
      transition="nice-modal-fade"
      :pivotY="0.2"
      :min-width="200"
      :min-height="200"
      height="auto"
      :delay="50"
    >
      <div
        class="pk-flex-column"
        style="height: 100%; padding: 30px; font-size: 1.1em"
      >
        <div class="pk-label-primary" style="font-size: 1.2em">
          Save configuration
        </div>
        <div class="pk-flex-1" style="padding: 20px 0">
          You can download a configuration file with the extension json. Check
          your download directory.
        </div>
        <div class="pk-flex-1" style="padding: 20px 0">
          File name:<b-form-input
            v-model="configName"
            type="text"
          ></b-form-input>
        </div>
        <div class="pk-flex">
          <b-button
            class="pk-flex__1"
            @click="clickSaveBtn()"
            style="margin-right: 20px"
          >
            Save
          </b-button>
          <b-button class="pk-flex__1" @click="$modal.hide('saveConfigModal')">
            Cancel
          </b-button>
        </div>
      </div>
    </modal>
    <modal
      name="timelineHelp"
      transition="nice-modal-fade"
      :pivotY="0.2"
      :min-width="200"
      :min-height="500"
      height="auto"
      :delay="50"
    >
      <div
        class="pk-flex-column"
        style="height: 100%; padding: 30px; font-size: 1.1em"
      >
        <div class="pk-label-primary" style="font-size: 1.2em">Help ?</div>
      </div>
    </modal>

    <div ref="timeline-info" class="g-info-wrapper">
      <div v-if="infoData" style="padding: 10px" class="g-info-content">
        <div>
          {{ infoData.headerTitel }}
        </div>
        <div v-html="infoData.html"></div>
      </div>
    </div>
    <div style="display: none" id="g-drag-template">
      <div class="g-drag-box">
        <div class="g-drag-header pk-flex--between" style="align-items: center">
          <span class="g-drag-title">text</span>
          <div class="pk-flex__vh-center">
            <img
              class="_zu _box-img"
              src="../assets/icons/timeline/box-zuklappen-weiss.svg"
            />
            <img
              class="_auf _box-img g-display-none"
              src="../assets/icons/timeline/box-aufklappen-weiss.svg"
            />
            <img
              class="_close _box-img"
              src="../assets/icons/timeline/box-schliessen-weiss.svg"
            />
          </div>
        </div>
        <div class="g-drag-main"></div>
      </div>
    </div>
    <div class="pk-page-spacing-flex" style="position: relative">
      <div class="g-timeline_zoombtn-wrapper">
        <img
          class="g-timeline_zoombtn pk-flex__vh-center noselet"
          :class="{ 'zoombtn-disable': zoomVal >= 450 }"
          @click="zoomClick(2)"
          :src="$_getSvg('timeline/zeitleiste-zoom-plus.svg')"
        />
        <img
          class="g-timeline_zoombtn pk-flex__vh-center noselet"
          :class="{ 'zoombtn-disable': zoomVal <= 1 }"
          @click="zoomClick(0.5)"
          :src="$_getSvg('timeline/zeitleiste-zoom-minus.svg')"
        />
      </div>
    </div>
    <div ref="timeline-svg-container" class="g-timeline__svg-container">
      <div class="datepicker-from-wrapper pk-flex__vh-center">
        <VueDatePicker
          v-model="datePickerFrom"
          @onOpen="openDatePicker(0)"
          @onChange="changeDatePicker(0)"
          format="YYYY-MM-DD"
          :noHeader="true"
          local="en"
          :min-date="minDate"
          :max-date="maxDateFrom"
        />
        <span class="_year"></span>
        <span class="_month_day"></span>
      </div>
      <div class="datepicker-to-wrapper pk-flex__vh-center">
        <VueDatePicker
          v-model="datePickerTo"
          @onOpen="openDatePicker(1)"
          @onChange="changeDatePicker(1)"
          format="YYYY-MM-DD"
          formatHeader="YYYY-MM-DD"
          :noHeader="true"
          local="en"
          :min-date="minDateTo"
          :max-date="maxDate"
        />
        <span class="_year"></span>
        <span class="_month_day"></span>
      </div>
      <svg
        ref="timeline-svg"
        id="timeline-svg"
        width="100%"
        height="100%"
        preserveAspectRatio="xMinYMin meet"
      ></svg>
    </div>
    <div class="pk-page-spacing-flex"></div>
  </div>
</template>

<script>
import * as d3 from "d3";
import * as moment from "moment";
import * as $ from "jquery";

const csv = "static/PH-events zu_timeline_arbeitsauswahl2020-11-11.csv";
const dateFormat = "YYYY-MM-DD";

const timeFormatYearFunc = function (d) {
  if (d.getMinutes()) {
    return;
  } else if (d.getHours()) {
    return;
  } else if (d.getDay() && d.getDate() != 1) {
    return;
  } else if (d.getDate() != 1) {
    return;
  } else if (d.getMonth()) {
    return;
  } else {
    return d3.timeFormat("%Y")(d);
  }
};

export default {
  props: [],
  data() {
    return {
      margin: { top: 0, right: 0, bottom: 20, left: 0 },
      margin2: { top: 20, right: 0, bottom: 5, left: 0 },
      brushBound: {},
      mainBound: [],
      allTimelineLayerCount: 0,
      zoomScaleExtent: [1, 1000],
      tickWith: 80,
      infoData: null,
      brushHeight: 80,
      brushMinWidth: 5,
      brushPadding: 8, //
      brushMarginBottom: 2,
      brushLayerSpacing: 1,
      timelineDuration: 0,
      timelinePadding: 25,
      timelineMarginBottom: 10,
      timelineLayerSpacing: 10, //Abstand zwischen Event Streifen
      timelineRectMaxHeight: 20,
      timelineRectMinWidth: 4,
      timelineLayerMaxHeight: 540,
      timelineToolbarWidth: 18,
      timelineCollapseHeight: 18,
      timelineMinHeight: 140,
      overlayGrad: 10,
      maxZindex: 0,
      standardLayerHeight: 0,
      zoomVal: 2,
      configName: "",
      timelineTemplate: {
        idx: 0,
        selected: true,
        collapse: false,
        class: "tl-0",
        name: "eLaterna Timeline",
        axisType: "year",
        layerCount: 0,
        rectHeight: 0,
        height: 0,
      },

      timelineList: [],
      datePickerFrom: "",
      datePickerTo: "",
      dateSelection: "",
      minDate: "",
      maxDate: "",
      maxDateFrom: "",
      minDateTo: "",
    };
  },
  created: function () {
    this.$store.dispatch("fetchTimelineData");
  },

  computed: {
    timelineData() {
      return this.$store.state.timelineData;
    },
    timelineNavEvent() {
      return this.$store.state.timelineNavEvent;
    },
  },
  watch: {
    timelineData(d) {
      if (!this.xScale) {
        const vue = this;
        setTimeout(function () {
          vue.initData(d);
        }, 200);
      }
    },
    timelineNavEvent(d) {
      const eventName = d.split(" ")[0];
      const vue = this;
      if (eventName == "ausblenden") {
        // const list = this.getDragBox();
        // list.forEach((d) => {
        //   vue.hiddenDragBox(d, "hidden", true);
        // });
        this.hiddenDateRect(true);
        this.$store.commit("dragbox-einblenden", true);
        this.$store.commit("dragbox-ausblenden", false);
      } else if (eventName == "einblenden") {
        // const list = this.getDragBox();
        // list.forEach((d) => {
        //   vue.hiddenDragBox(d, "show", false);
        // });
        this.hiddenDateRect(false);
        this.$store.commit("dragbox-einblenden", false);
        this.$store.commit("dragbox-ausblenden", true);
      } else if (eventName == "speichern") {
        this.$modal.show("saveConfigModal");
      } else if (eventName == "laden") {
        this.openFilemanager();
      } else if (eventName == "hilfe") {
        this.$modal.show("timelineHelp");
      }
    },
  },
  mounted: function () {
    const vue = this;
    const svg = d3.select("#timeline-svg");
    // if (this.timelineData) {
    //   this.initData(this.timelineData);
    // }

    $("#loadSetup").on("change", function (e) {
      let file = e.target.files[0];
      if (file) {
        vue.fileName = file.name;
        vue.readConfigFile(file);
      }
    });
  },
  methods: {
    openDatePicker(idx) {
      const ds = this.dateSelection;
      if (idx == 0) {
        // from
        this.datePickerFrom = ds[0];
        this.maxDateFrom = moment(ds[1]).add(-24, "months").format(dateFormat);
      } else {
        this.datePickerTo = ds[1];
        this.minDateTo = moment(ds[0]).add(24, "months").format(dateFormat);
      }
    },
    changeDatePicker(idx) {
      const vue = this;
      const xScale2 = vue.xScale2;
      const ds = this.dateSelection;
      if (idx == 0) {
        ds[0] = moment(this.datePickerFrom);
      } else {
        ds[1] = moment(this.datePickerTo);
      }
      const extent = [xScale2(ds[0]), xScale2(ds[1])];
      vue.brushMoving = true;
      //时间选择块动画
      vue.brushContainer
        .select(".brush")
        .call(vue.brush)
        .transition()
        .duration(100)
        .call(vue.brush.move, extent);
      setTimeout(function () {
        vue.brushMoving = false;
      }, 200);
    },

    readConfigFile(file) {
      if (!file) {
        return;
      }

      const reader = new FileReader();
      const vue = this;
      reader.onloadend = function () {
        const str = reader.result;
        const json = JSON.parse(str);

        // //brush 选时间
        const ds = json.dateSelection;
        const wFactor = vue.width / json.width;
        const hFactor = vue.height / json.height;
        vue.dateSelection = [moment(ds[0]), moment(ds[1])];

        json.timeline.forEach((_tl) => {
          const tl = vue.timelineList.find((m) => m.name == _tl.name);
          if (tl) {
            tl.collapse = _tl.collapse;
          }
        });

        //开始重绘
        vue.setWrapperSize();

        //打开dragbox
        const dragBox = json.dragBox;
        if (dragBox.length > 0) {
          vue.timelineList.forEach((tl) => {
            tl.data.forEach((d) => {
              d._drag = null;
              for (const _d of dragBox) {
                if (_d.docID == d.docID) {
                  const opt = JSON.parse(JSON.stringify(_d._drag));
                  opt.distX = wFactor * opt.distX;
                  opt.distY = hFactor * opt.distY;
                  opt.left = wFactor * opt.left;
                  opt.top = hFactor * opt.top;
                  vue.openDragBox({
                    data: d,
                    _dragOption: opt,
                  });
                }
              }
            });
          });
        }
      };
      reader.readAsText(file);
    },

    getConfig() {
      return {
        width: this.width,
        height: this.height,
        dragBox: this.getDragBox().map((d) => {
          const dg = d._drag;
          return {
            docID: d.docID,
            _drag: {
              collapse: dg.collapse,
              distX: dg.distX,
              distY: dg.distY,
              left: dg.left,
              top: dg.top,
              status: dg.status,
              x: dg.x,
              y: dg.y,
            },
          };
        }),
        timeline: this.timelineList.map((tl) => {
          return {
            name: tl.name,
            collapse: tl.collapse,
          };
        }),
        dateSelection: this.dateSelection.map((d) =>
          moment(d).format(dateFormat)
        ),
      };
    },
    clickSaveBtn() {
      const name = this.configName.trim();
      if (name == "") {
        return;
      }
      this.$modal.hide("saveConfigModal");
      this.configName = "";
      const vue = this;
      vue.$store
        .dispatch("saveConfig", {
          fileName: name,
          data: vue.getConfig(),
        })
        .then((res) => {
          // vue.showModal = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    openFilemanager() {
      if (
        !window.File ||
        !window.FileReader ||
        !window.FileList ||
        !window.Blob
      ) {
        alert("Your browser does not support load local file.");
        return;
      }

      $("#loadSetup").trigger("click");
    },

    getRefs(html) {
      const div1 = document.createElement("div");
      div1.innerHTML = html;
      const refs = div1.querySelectorAll("ref");
      const out = [];
      if (refs) {
        for (const r of refs) {
          out.push(r.getAttribute("target"));
        }
      }
      return out;
    },

    fudTextToHtml1(text) {
      text = text.replace("<hi", "<span");
      text = text.replace("</hi>", "</span>");
      text = text.replace("<lb/>", "<br>");
      text = text.replace("<ref", "<a");
      text = text.replace("</ref>", "</a>");
      text = text.replace('rend="weight:bold"', 'style="font-weight:bold"');
      text = text.replace('<a target="', '<a target="_blank" href="');
      return text;
    },

    getLink(html, refs) {
      const pattern = /<span class=\"(.*?)\"/g;
      const div = document.createElement("div");
      let newHtml = "";
      html.split("<br>").forEach((a, i) => {
        newHtml += a;
        if (i % 2 == 0) {
          newHtml += "<p>";
        } else {
          newHtml += "</p>";
        }
      });
      div.innerHTML = newHtml;

      let refIdx = 0;
      while (pattern.exec(html)) {
        const spans = div.querySelectorAll("span");
        spans.forEach((span) => {
          let spanclass = span.className;
          if (spanclass.indexOf("id-http") >= 0) {
            let href = refs[refIdx];
            refIdx++;
            const a = document.createElement("a");
            a.href = href;
            a.target = "_blank";
            a.innerHTML = span.innerHTML;
            span.parentNode.insertBefore(a, span);
            span.parentNode.removeChild(span);
          }
        });
      }
      return div.innerHTML;
    },

    initData() {
      const vue = this;
      const obj = {};
      const { getRefs, getLink } = this;
      this.timelineData.forEach((d) => {
        const sour = d;

        if (sour["58_evpublish"] != "yes") {
          return;
        }

        const cases = sour["58_tf_casestudy"];
        let from = sour["58_evfromdate"];
        let to = sour["58_evtodate"];
        let text = sour["58_tf_eventtext"];
        let eventText = sour["eventtext_from_db"];
        let html = getLink(text, getRefs(eventText));

        // console.log(html);
        // console.error(getLink(text));
        // if (sour.ID == 130259) {
        // }
        if (sour.ID == 130415) {
          // console.error(html);
        }

        const location = sour["58_lclocation"];
        const placeEnglish = sour["58_lcplaceen"];
        const placeSour = sour["58_lcnplacesour"];
        let placeStr = sour["58_lcplace"];

        let placeKlammer = [placeSour, placeEnglish]
          .filter((p) => p && p.trim)
          .join("; ");

        if (placeKlammer) {
          placeStr = placeStr + " (" + placeKlammer + ")";
        }

        placeStr = [placeStr, location].filter((p) => p && p.trim).join(", ");

        if (placeStr && html) {
          html = [placeStr, html].join(". ");
        }

        const from_c = sour["58_evfromcomment"];
        const to_c = sour["58_evtocomment"];

        let from_prefix = "";
        let to_prefix = "";
        if (from_c) {
          if (from_c == "before") {
            from_prefix = "≤"; //&le;
          } else if (from_c == "after") {
            from_prefix = "≥"; //&ge;
          }
        }

        if (to_c) {
          if (to_c == "before") {
            to_prefix = "≤";
          } else if (to_c == "after") {
            to_prefix = "≥";
          }
        }

        let headerTitel = "";

        if (!from) {
          console.log(d);
          return;
        }
        from = from.replace("-00-00", "");
        if (!to || to == from) {
          to = from;
          headerTitel = from_prefix + from;
        } else {
          headerTitel = [from_prefix + from, to_prefix + to].join(" — ");
        }

        if (sour["58_displaydate"]) {
          headerTitel = sour["58_displaydate"];
        }

        cases.forEach((tl) => {
          if (!obj[tl]) {
            obj[tl] = [];
          }
          if (cases.indexOf(tl) >= 0) {
            const categorie = sour["58_tf_category"];
            let image = "event-gelb";
            let isEvent, isPeo, isTech, color, isPub;
            if (categorie) {
              categorie.forEach((c) => {
                isEvent = c.match(/events/i);
                isPeo = c.match(/people/i);
                isTech = c.match(/technology/i);
                isPub = c.match(/publication/i);
                color = c.match(/historical/i) ? "rot" : "gelb-neu";
              });
              if (isTech && isEvent) {
                image = "technology-event-" + color;
              } else if (isTech && isPeo) {
                image = "technology-people-" + color;
              } else if (isEvent && isPeo) {
                image = "event-people-" + color;
              } else if (isTech) {
                image = "technology-" + color;
              } else if (isEvent) {
                image = "event-" + color;
              } else if (isPeo) {
                image = "people-" + color;
              } else if (isPub) {
                image = "publication-" + color;
              }
            } else {
              return;
            }
            image = vue.$_getSvg("timeline/" + image + ".svg");

            let unclear = "";
            if (from_c && to_c) {
              unclear = "unclear_beforeAfter";
            } else if (from_c) {
              unclear = "unclear_before";
            } else if (to_c) {
              unclear = "unclear_after";
            }
            const dateVon = moment(from);
            const dateBis = moment(to).add(23, "hours");
            const diff = dateBis.diff(dateVon);
            obj[tl].push({
              docID: sour.ID,
              // from: from,
              // to: to,
              // sour: sour,
              // text: text,
              // timeline: cases,
              // categorie: categorie,
              // headerTitel: headerTitel + "---" + sour.ID,
              headerTitel: headerTitel,
              unclear: unclear,
              dateVon: dateVon,
              dateBis: dateBis,
              html: html,
              x: 0,
              y: 0,
              w: 0,
              h: 0,
              diff: diff,
              overlay: false,
              image: image,
            });
          }
        });
      });

      const list = vue.timelineList;

      //timeline sortieren， Item  add to timeline
      Object.keys(obj)
        .sort((a, b) => {
          if (a < b) {
            return 1;
          } else if (a > b) {
            return -1;
          }
          return 0;
        })
        .forEach((k, i) => {
          const tl = JSON.parse(JSON.stringify(vue.timelineTemplate));
          const cl = "tl-" + i;
          tl.idx = i;
          if (i == 0) {
            tl.colorDark = "#005ca9";
            tl.color = "#5585c4";
          } else if (i == 1) {
            tl.colorDark = "#006d78";
            tl.color = "#22929d";
          } else {
            tl.colorDark = "#492a72";
            tl.color = "#765e97";
          }
          tl.class = cl;
          tl.name = k;
          tl.data = obj[k].sort((a, b) => {
            // return a.dateVon - b.dateVon;
            return b.diff - a.diff;
          });

          tl.data.forEach((d, i) => {
            d.tl = cl;
          });
          list.push(tl);
        });
      //wie viele Layer
      let allTimelineLayerCount = 0;
      list.forEach((t) => {
        const layerCount = vue.setDataLayers(t.data);
        allTimelineLayerCount += layerCount;
        t.layerCount = layerCount;
      });
      vue.allTimelineLayerCount = allTimelineLayerCount;

      //init
      vue.initBaseOnce();
      vue.initSvgOnce();

      vue.setTimelineData();

      vue.setWrapperSize();
    },

    fullscreen() {
      if (!document.fullscreenElement) {
        document.querySelector("#tmp").requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    },

    //ausgeführt wenn Daten geändert
    setTimelineData() {
      const vue = this;
      const { xScale, xScaleYear, xScale2, yScale2, timelineList } = this;

      // domain anpassen
      let data = [];
      timelineList.forEach((tl) => {
        data = data.concat(tl.data);
      });
      const extentVon = d3.extent(data, function (d) {
        return d.dateVon;
      });
      const extentBis = d3.extent(data, function (d) {
        return d.dateBis;
      });
      const minDate = moment(extentVon[0]).add(-24, "months");
      const maxDate = moment(extentBis[1]).add(24, "months");
      xScale.domain([minDate, maxDate]);
      xScaleYear.domain(xScale.domain());

      vue.minDate = minDate.format(dateFormat);
      vue.maxDate = maxDate.format(dateFormat);

      xScale2.domain(xScale.domain());
      yScale2.domain([0, 10]);

      vue.brushContainer
        .selectAll(".brush-background-container")
        .select("*")
        .remove();

      timelineList.forEach((tl) => {
        if (tl.container) {
          // tl.container.data([]).exit().remove()();
          tl.container.remove();
        }
        tl.container = null;

        if (tl.backgroundRect) {
          tl.backgroundRect.data([]).exit().remove();
        }
        tl.backgroundRect = null;

        tl.xAxis = tl.axisType == "month" ? vue.xAxis : vue.xAxisYear;
      });
    },

    redrawAllTimeline() {
      const vue = this;
      const {
        timelineCollapseHeight,
        timelineMinHeight,
        timelineLayerMaxHeight,
        timelinePadding,
        timelineMarginBottom,
        height,
      } = this;

      let allDrawAreaHeight = height - 0;
      let lastLayerY = 0;

      // Height für jede Timeline
      let validLayerCount = 0;

      let timelinePaddingSumme = 0;

      vue.timelineList.forEach((tl) => {
        timelinePaddingSumme += timelinePadding * 2;
        if (!tl.collapse) {
          validLayerCount += tl.layerCount;
        } else {
          allDrawAreaHeight = allDrawAreaHeight - timelineCollapseHeight;
        }
      });

      let standardLayerHeight =
        (allDrawAreaHeight - timelinePaddingSumme) / validLayerCount;

      if (standardLayerHeight > timelineLayerMaxHeight) {
        standardLayerHeight = timelineLayerMaxHeight;
      }
      if (standardLayerHeight < 1) {
        standardLayerHeight = 1;
      }

      this.standardLayerHeight = standardLayerHeight;

      vue.timelineList.forEach((tl) => {
        if (tl.collapse) {
          tl.height = timelineCollapseHeight + timelineMarginBottom;
        } else {
          tl.height = tl.layerCount * standardLayerHeight + timelinePadding * 2;
          // tl.height = (tl.layerCount / validLayerCount) * allDrawAreaHeight;
          tl.height =
            tl.height >= timelineMinHeight ? tl.height : timelineMinHeight;
        }

        vue.drawSingleTimeline({
          parent: vue.mainContainer,
          yLeft: vue.leftAxisContainer,
          tl: tl,
          offsetX: 0,
          offsetY: lastLayerY,
          reset: true,
        });
        lastLayerY += tl.height;
      });
    },

    drawSingleTimeline(opt) {
      const { parent, yLeft, tl, offsetX, offsetY } = opt;
      const vue = this;
      const {
        timelinePadding,
        timelineLayerSpacing,
        timelineCollapseHeight,
        timelineDuration,
        timelineMarginBottom,
        timelineRectMaxHeight,
        standardLayerHeight,
        width,
        xScale,
        timelineToolbarWidth,
      } = this;

      //确定每个layer的 y 坐标
      const y = offsetY + timelinePadding;
      let layerHeight = standardLayerHeight - 0;
      let rectHeight = layerHeight - timelineLayerSpacing;

      if (rectHeight > timelineRectMaxHeight) {
        rectHeight = timelineRectMaxHeight;
      }
      if (rectHeight < 1) {
        rectHeight = 1;
      }

      tl.rectHeight = rectHeight;

      if (tl.collapse) {
        layerHeight = 0;
        rectHeight = 0;
        tl.rectHeight = 0;
      }

      tl.data.forEach((d) => {
        d.y = y + d.layer * layerHeight;
        d.h = rectHeight;
      });

      if (!tl.container) {
        const container = parent
          .append("g")
          .attr("class", "tl-container " + tl.class);
        tl.gridContainer = container.append("g").attr("class", "tl-grid");
        tl.gridScale = d3.scaleTime();
        //   .domain(xScale.domain())
        //   .range(xScale.range());
        // tl.gridScale = gridScale;
        // tl.gridAxis = d3
        //  .axisBottom(tl.gridScale)
        //   .ticks(width / vue.tickWith)
        //   .tickFormat("");

        //x 时间轴
        tl.xAxisContainer = container.append("g").attr("class", "axis axis--x");
        tl.container = container;

        //timeline 背景色
        tl.backgroundRect = yLeft
          .append("rect")
          .attr("class", tl.class + " _background");

        //根据数据生成 时间方块
        //时间方块 背景
        container
          .selectAll("all-date-rect")
          .data(tl.data)
          .enter()
          .append("rect")
          .attr("class", function (d) {
            return "g-date-rect " + d.unclear;
          });

        //时间方块 icons 中心
        container
          .selectAll("all-date-image")
          .data(tl.data)
          .enter()
          .append("svg:image")
          .attr("class", "g-date-image")
          .attr("xlink:href", function (d) {
            return d.image;
          });

        //如果没有添加工具条
        tl.toolbar = container.append("g").attr("class", "tl-toolbar");

        //按钮
        tl.toolbar
          .append("svg:image")
          .attr("class", "_btn-image " + tl.class)
          .attr("width", 18)
          .attr("height", 18)
          .attr("x", 0)
          .attr("y", 0)
          .on("click", function () {
            tl.collapse = !tl.collapse;
            vue.timelineDuration = 300;
            vue.setWrapperSize();
            vue.timelineDuration = 0;
          })
          .append("title");

        //工具条 标题 背景
        tl.toolbar
          .append("rect")
          .attr("class", "_label-bg " + tl.class)
          .attr("x", 0)
          .attr("y", timelineCollapseHeight)
          .attr("width", timelineToolbarWidth);

        //工具条 标题
        tl.toolbar
          .append("text")
          .attr("class", "_label")
          .attr("transform", "rotate(-90)")
          .attr("dy", "1.2em")
          .style("text-anchor", "middle")
          .text(tl.name)
          .transition()
          .duration(timelineDuration)
          .attr("x", -0 - timelineToolbarWidth * 4)
          .attr("y", 0);
      }

      //背景线条
      tl.gridScale.domain(xScale.domain()).range(xScale.range());
      tl.gridAxis = d3
        .axisBottom(tl.gridScale)
        .ticks(width / vue.tickWith)
        .tickFormat("");

      //时间轴
      tl.xAxisContainer
        .call(tl.xAxis)
        .transition()
        .duration(timelineDuration)
        .attr(
          "transform",
          "translate(0," +
            (offsetY + tl.height - timelinePadding - timelineMarginBottom + 5) +
            ")"
        );

      tl.xAxisContainer.selectAll("text").style("color", function (d) {
        if (d.getMonth() == 0 && d.getDate() == 1) {
          return "black";
        }
        return tl.colorDark;
      });

      tl.gridContainer
        .call(tl.gridAxis.tickSize(tl.height - 35))
        .attr("transform", "translate(0," + offsetY + ")");

      // date rect 高度
      tl.container.selectAll(".g-date-rect").attr("height", rectHeight);
      tl.container
        .selectAll(".g-date-image")
        .attr("y", -4)
        .attr("height", rectHeight + 8);

      //背景色
      tl.backgroundRect
        .attr("x", offsetX)
        .transition()
        .duration(timelineDuration)
        .attr("y", offsetY)
        .attr("width", width)
        .attr("height", tl.height - timelineMarginBottom);

      setTimeout(function () {
        //隐藏 timeline 标题
        tl.toolbar.select("._label").classed("g-hidden", tl.collapse);
        //隐藏 时间轴
        tl.xAxisContainer.classed("g-hidden", tl.collapse);
        //隐藏 dragbox
        vue.svgContainer
          .selectAll(".g-drag-wrapper." + tl.class)
          .classed("g-hidden", tl.collapse);
        //隐藏 dragbox-line
        vue.svgContainer
          .selectAll(".g-drag-line." + tl.class)
          .classed("g-hidden", tl.collapse);
        //隐藏 dragbox-circle
        vue.svgContainer
          .selectAll(".g-drag-circle." + tl.class)
          .classed("g-hidden", tl.collapse);
        //隐藏时间方块
        tl.container
          .selectAll(".g-date-image")
          .classed("g-hidden", tl.collapse);
        tl.gridContainer.classed("g-hidden", tl.collapse);
      }, timelineDuration - 100);

      //标题背景
      tl.toolbar
        .select("._label-bg")
        .transition()
        .duration(timelineDuration)
        .attr("height", tl.collapse ? 0 : 110);

      //是否隐藏时间轴
      // setTimeout(() => {
      //   tl.xAxisContainer.classed("g-hidden", tl.collapse);
      // }, timelineDuration - 100);

      tl.toolbar
        .transition()
        .duration(timelineDuration)
        .attr("transform", "translate(0," + offsetY + ")");

      tl.toolbar
        .select("._btn-image")
        .attr("xlink:href", function () {
          let svgName = "timeline/zeitleiste-aufklappen-blau2.svg";
          if (!tl.collapse) {
            svgName = svgName.replace("aufklappen", "zuklappen");
          }

          if (tl.class == "tl-0") {
          } else if (tl.class == "tl-1") {
            svgName = svgName.replace("blau2", "gruen2");
          } else {
          }

          return vue.$_getSvg(svgName);
        })
        .select("title")
        .text(function () {
          return tl.collapse ? "expand timeline" : "minimise timeline";
        });
    },

    zoomClick(val) {
      const vue = this;
      vue.clickZoomBtn = true;
      // vue.zoom.scaleBy(vue.zoomRect.transition().duration(500), val);
      vue.zoom.scaleBy(vue.mainContainer.transition().duration(500), val);
      setTimeout(function () {
        vue.clickZoomBtn = false;
      }, 500);
    },

    setDataLayers(data) {
      const layers = [];
      layers[0] = [];
      const overlayGrad = this.overlayGrad; //大于多少天就叠加
      const testInsection = function (i, c) {
        if (!layers[i]) {
          layers[i] = [c];
          return true;
        }
        let hasInsection = false;
        for (let m of layers[i]) {
          //如果有相交,继续检查
          if (
            c.dateVon > m.dateBis.clone().add(overlayGrad, "days") ||
            m.dateVon > c.dateBis.clone().add(overlayGrad, "days")
          ) {
          } else {
            //如果有相交,继续检查
            hasInsection = true;
            break;
          }
        }
        if (hasInsection) {
          return testInsection(i + 1, c);
        } else {
          layers[i].push(c);
          return true;
        }
      };

      data.forEach((d) => {
        testInsection(0, d);
      });

      layers.forEach((m, i) => {
        m.forEach((d, j) => {
          d.layer = i;
        });
      });

      return layers.length;
    },

    //一次性
    initBaseOnce() {
      const vue = this;
      // 刻度尺
      vue.xScale = d3.scaleTime();
      vue.xScaleYear = d3.scaleTime();

      vue.xScale2 = d3.scaleTime();
      vue.yScale2 = d3.scaleLinear();

      vue.xAxis = d3.axisBottom(vue.xScale);
      vue.xAxisYear = d3.axisBottom(vue.xScaleYear);
      // .tickFormat(timeFormatYearFunc);

      vue.xAxis2 = d3.axisBottom(vue.xScale2);

      //brush
      // vue.brush = d3.brushX().on("brush end", function (event) {
      //   if (!event.sourceEvent) return; // ignore brush-by-zoom
      //   const s = event.selection || vue.xScale2.range();
      //   vue.brushed(s);
      // });
      vue.brush = d3.brushX().on("brush end", ({ sourceEvent, selection }) => {
        if (!sourceEvent && !vue.brushMoving) return;
        vue.brushed(selection);
      });

      //zoom
      vue.zoom = d3
        .zoom()
        .scaleExtent(vue.zoomScaleExtent)
        .on("zoom", vue.zoomed);

      window.addEventListener("resize", function () {
        vue._debounce(function () {
          vue.setWrapperSize();
        }, 300);
      });
    },

    initSvgOnce() {
      const vue = this;
      const refSvg = vue.$refs["timeline-svg"];
      if (!refSvg) {
        return;
      }
      vue.datePickerFromWrapper = vue.$el.querySelector(
        ".datepicker-from-wrapper"
      );
      vue.datePickerToWrapper = vue.$el.querySelector(".datepicker-to-wrapper");

      const svg = d3.select(refSvg);
      vue.svg = svg;
      vue.infoRef = vue.$refs["timeline-info"];
      vue.infoBox = d3.select(vue.infoRef);

      svg.on("mousemove", function (e) {
        const target = d3.select(e.target);
        const b = vue.brushBound;
        // const m = vue.mainBound;
        //20 来自 g-timeline__svg-container 的 margin
        const x = e.clientX - vue.spacingWidth;
        const y = e.clientY - 60 - 25;
        // x = e.clientX,

        //显示brush时间线
        const brushDateText = vue.brushDateText;
        if (
          x >= b.x &&
          x <= b.x + b.w &&
          y >= b.y &&
          y <= b.y + b.h &&
          !target.classed("selection")
        ) {
          vue.brushDateLineWapper
            .attr("transform", "translate(" + [x, -10] + ")")
            .selectAll("*")
            .classed("active", true);
          brushDateText.text(moment(vue.xScale2.invert(x)).format(dateFormat));
          const textW = brushDateText.node().getBBox().width;
          let rectX = -(textW + 10) / 2;
          let textX = -textW / 2;
          if (x < -rectX) {
            rectX = -x;
            textX = -x;
          } else if (b.w - x - 5 < -rectX) {
            rectX = b.w - x - textW - 5;
            textX = b.w - x - textW - 5;
          }
          brushDateText.attr("x", textX);
          vue.brushDateRect.attr("width", textW + 10);
          vue.brushDateRect.attr("x", rectX);
        } else {
          brushDateText.text("");
          vue.brushDateLineWapper.selectAll("*").classed("active", false);
        }
      });
      // vue.svg.on('contextmenu', function (event) {
      //   console.log('contextMenu');
      //   event.preventDefault();
      // });

      vue.leftAxisContainer = svg
        .append("g")
        .attr("class", "leftAxisContainer");

      const defs = svg.append("defs");

      vue.timelineList.forEach((tl) => {
        //beforeAfter
        const beforeAfter = defs
          .append("linearGradient")
          .attr("id", tl.class + "-beforeAfter");
        beforeAfter
          .append("stop")
          .attr("class", tl.class + " stop-light")
          .attr("offset", "0");

        beforeAfter
          .append("stop")
          .attr("class", tl.class + " stop-dark")
          .attr("offset", "20%");
        beforeAfter
          .append("stop")
          .attr("class", tl.class + " stop-dark")
          .attr("offset", "80%");

        beforeAfter
          .append("stop")
          .attr("class", tl.class + " stop-light")
          .attr("offset", "100%");

        //from
        const stopFrom = defs
          .append("linearGradient")
          .attr("id", tl.class + "-before");
        stopFrom
          .append("stop")
          .attr("class", tl.class + " stop-light")
          .attr("offset", "0");

        stopFrom
          .append("stop")
          .attr("class", tl.class + " stop-dark")
          .attr("offset", "20%");

        //to
        const stopTo = defs
          .append("linearGradient")
          .attr("id", tl.class + "-after");
        stopTo
          .append("stop")
          .attr("class", tl.class + " stop-dark")
          .attr("offset", "80%");
        stopTo
          .append("stop")
          .attr("class", tl.class + " stop-light")
          .attr("offset", "100%");
      });

      // add clipPath
      vue.clipPath = defs.append("clipPath").attr("id", "clip").append("rect");

      // add mainContainer
      const mainContainer = svg
        .append("g")
        .attr("class", "main-container")
        .attr("clip-path", "url(#clip)");

      vue.mainContainer = mainContainer;

      // add mainContainer mousemove
      //Throttle and Debounce
      d3.select(window).on("mousemove", function (event) {
        const { infoBox, infoRef } = vue;
        const target = d3.select(event.target);
        let infoData;

        // console.log( event.clientX,event.clientY,  [0, 60 + 25, vue.$el.clientWidth, vue.$el.clientHeight+60 + 25]);
        //  return;
        if (target.classed("g-date-rect") || target.classed("g-date-image")) {
          infoData = target.data()[0];
          if (vue.infoData != infoData) {
            infoBox.style("visibility", "hidden");
          }
          vue.infoData = infoData;
        } else {
          infoBox.style("visibility", "hidden");
          vue.infoData = null;
          return;
        }

        vue._debounce(function () {
          const pos = vue.autoLabelPlacement({
            cx: event.clientX,
            cy: event.clientY,
            w: 300,
            h: 400,
            parent: d3.select(vue.$el),
            bound: {
              x: 0,
              y: 60 + 25,
              w: vue.$el.clientWidth,
              h: vue.$el.clientHeight + 60 + 25,
            },
          });
          infoBox
            .style("justify-content", pos.justify)
            .style("align-items", pos.align);
          infoBox
            .style("left", pos.x + "px")
            .style("top", pos.y - 60 - 25 + "px"); //因为 move 是window , parent 是 $el, 所以有y轴误差，要纠正回来
          infoBox.style("visibility", "visible");
        }, 100);
      });

      //暂时取消弹出菜单
      // mainContainer.on("click", function (event) {
      //   vue.infoData = null;
      //   const target = d3.select(event.target);
      //   if (target.classed("g-date-image")) {
      //     vue.dd = target.data()[0];
      //     const x = event.clientX + 20;
      //     const y = event.clientY - vue.mouseMarginTop + 10;
      //     vue.menuBox.style("left", x + "px").style("top", y + "px");
      //   } else {
      //     vue.dd = null;
      //   }
      // });

      mainContainer.on("click", function (event) {
        const target = d3.select(event.target);
        if (target.classed("g-date-rect") || target.classed("g-date-image")) {
          vue.openDragBox({ data: target.data()[0], event: event });
          vue.infoData = null;
        }
      });

      // add zoom rect
      // vue.zoomRect = mainContainer.append("rect").attr("class", "zoom");

      // add brushContainer
      const brushContainer = svg
        .append("g")
        .attr("class", "brushContainer")
        .on("dblclick", function (e) {
          const x = e.clientX - vue.spacingWidth;
          const xScale2 = vue.xScale2;
          const width = vue.width;
          const dist =
            xScale2(vue.dateSelection[1]) - xScale2(vue.dateSelection[0]);
          let von = x - dist / 2;
          let bis = dist / 2 + x;
          if (von < 0) {
            von = 0;
            bis = dist;
          }
          if (bis > width) {
            bis = width;
            von = width - dist;
          }
          const extent = [von, bis];
          vue.dateSelection = [xScale2.invert(von), xScale2.invert(bis)];
          vue.brushMoving = true;
          //时间选择块动画
          vue.brushContainer
            .select(".brush")
            .call(vue.brush)
            .transition()
            .duration(300)
            .call(vue.brush.move, extent);
          setTimeout(function () {
            vue.brushMoving = false;
          }, 400);
        });
      vue.brushContainer = brushContainer;

      brushContainer.append("g").attr("class", "brush-background-container");

      const foreignObject = brushContainer.append("foreignObject");
      vue.brushForeignObject = foreignObject;
      const foBody = foreignObject
        .append("xhtml:body")
        .style("margin", "0")
        .style("background-color", "transparent")
        .style("padding", "0");
      vue.brushForeignBody = foBody;
      const canvas = foBody.append("canvas").attr("x", 0).attr("y", 0);
      vue.brushFoCanvas = canvas;

      //brush dateline wrapper
      const brushDateLineWapper = brushContainer
        .append("g")
        .attr("class", "brush-dateLine-g");
      vue.brushDateLineWapper = brushDateLineWapper;

      vue.brushDateRect = brushDateLineWapper
        .append("rect")
        .attr("x", 0)
        .attr("y", -20)
        .attr("height", "1.5em");

      vue.brushDateText = brushDateLineWapper.append("text").attr("y", -5);

      brushDateLineWapper
        .append("line")
        .attr("x1", 0)
        .attr("x2", 0)
        .attr("y1", 0);

      brushContainer.append("g").attr("class", "axis axis--x");
      brushContainer.append("g").attr("class", "brush");
    },

    // window 尺寸变化是执行
    setWrapperSize() {
      const { margin, margin2, brushHeight, tickWith, brushContainer } = this;
      const vue = this;

      //刷新容器尺寸
      const svgContainer = vue.$el.querySelector(".g-timeline__svg-container");
      if (!svgContainer) {
        console.log("no timeline__wrapper");
        return;
      }

      vue.spacingWidth = $(
        vue.$el.querySelector(".pk-page-spacing-flex")
      ).width();
      vue.svgContainer = d3.select(svgContainer);
      const w = svgContainer.clientWidth;
      vue.svgContainerClientWidth = w;

      vue.mouseMarginTop =
        margin.top + svgContainer.getBoundingClientRect().top;
      const width = +w - margin.left - margin.right,
        height =
          +svgContainer.clientHeight -
          margin.top -
          margin.bottom -
          brushHeight -
          margin2.top -
          margin2.bottom;

      if (height < 0) {
        return;
      }
      vue.width = width;
      vue.height = height;
      vue.mainBound = [margin.left, margin.top, width, height];
      //左边Y轴 自适应
      vue.leftAxisContainer.attr(
        "transform",
        "translate(" + margin.left + "," + margin.top + ")"
      );

      //缩放按钮 自适应
      const zoombuttons = vue.$el.querySelector(".g-timeline_zoombtn-wrapper");
      zoombuttons.style.top = height + margin.top + margin.bottom + "px";
      zoombuttons.style.left = vue.spacingWidth + "px";

      //刻度尺 自适应
      vue.xScale.range([0, width]);
      vue.xScaleYear.range([0, width]);

      vue.xAxis.ticks(width / tickWith);
      vue.xAxisYear.ticks(width / tickWith);

      vue.xScale2.range([0, width]);
      vue.yScale2.range([brushHeight, 0]);

      // vue.defaultBrushSelection = [
      //   vue.xScale(moment("1856-05-01")),
      //   vue.xScale(moment("1860-09-14")),
      // ];

      vue.defaultBrushSelection = [width / 2 - 50, width / 2 + 50];
      // vue.defaultBrushSelection = [
      // vue.xScale(moment("1845-03-01")),
      // vue.xScale(moment("1866-03-01")),
      // ];

      //clipPath 自适应
      vue.clipPath.attr("width", width).attr("height", height + 5);

      //mainContainer 自适应
      vue.mainContainer.attr(
        "transform",
        "translate(" + margin.left + "," + margin.top + ")"
      );

      // zoom 自适应
      vue.zoom
        .translateExtent([
          [0, 0],
          [width, height],
        ])
        .extent([
          [0, 0],
          [width, height],
        ]);
      // vue.zoomRect.attr("width", width).attr("height", height);
      // vue.zoomRect.call(vue.zoom);
      vue.mainContainer.call(vue.zoom);

      //brush 自适应
      vue.brush.extent([
        [0, 0],
        [width, brushHeight],
      ]);

      brushContainer.attr(
        "transform",
        "translate(" +
          margin2.left +
          "," +
          (+height + margin.top + margin.bottom) +
          ")"
      );

      vue.brushBound = {
        x: margin2.left,
        y: +height + margin.top + margin.bottom,
        w: width,
        h: brushHeight,
      };

      vue.brushFoCanvas.attr("width", width).attr("height", brushHeight);

      vue.redrawAllTimeline();
      vue.redrawBrushCanvas();

      //brush 日期选择线自适应
      vue.brushForeignObject
        .attr("width", width + "px")
        .attr("height", brushHeight + "px");
      vue.brushForeignBody
        .style("width", width + "px")
        .style("height", brushHeight + "px");
      vue.brushDateLineWapper.selectAll("line").attr("y2", brushHeight + 10);

      //brush 刻度自适应
      brushContainer
        .select(".axis--x")
        .attr("transform", "translate(0," + brushHeight + ")")
        .call(vue.xAxis2);

      const brushSelection = vue.dateSelection
        ? [vue.xScale2(vue.dateSelection[0]), vue.xScale2(vue.dateSelection[1])]
        : vue.defaultBrushSelection;

      vue.brushMoving = true;
      brushContainer
        .select(".brush")
        .call(vue.brush)
        .call(vue.brush.move, brushSelection);
      vue.brushMoving = false;

      if (!brushContainer.select(".handle--w .title")[0]) {
        brushContainer
          .select(".handle--w")
          .append("title")
          .text("choose start date");

        brushContainer
          .select(".handle--e")
          .append("title")
          .text("choose end date");
      }

      // datepicker 自适应
      vue.datePickerFromWrapper.style.bottom = brushHeight + 25 + "px";
      vue.datePickerToWrapper.style.bottom = brushHeight + 25 + "px";
    },

    _debounce(fn, wait) {
      wait = wait || 0;
      const vue = this;
      let timerId = this.timerId;
      function a_debounced() {
        if (timerId) {
          clearTimeout(timerId);
          timerId = null;
        }

        timerId = setTimeout(function () {
          fn();
        }, wait);
        vue.timerId = timerId;
      }

      return a_debounced();
    },

    autoLabelPlacement(opt) {
      const { cx, cy, w, h, parent, bound, startPos, nodes } = opt;
      const m = 50; //margin

      //从上面顺时针 0-8
      const x1 = cx - m - w;
      const x2 = cx - w / 2;
      const x3 = cx + m;
      const y1 = cy - m - h;
      const y2 = cy - h / 2;
      const y3 = cy + m;

      const jc = "center";
      const js = "flex-start";
      const je = "flex-end";
      const ac = "center";
      const ast = "flex-start";
      const ae = "flex-end";

      // let arr = [
      //   [x2, y1, w, h, "red", jc, ae, "top"],
      //   [x2, y3, w, h, "#888", jc, ast, "bottom"],
      //   [x3, y2, w, h, "blue", js, ac, "right"],
      //   [x1, y2, w, h, "#777", je, ac, "left"],
      //   [x3, y1, w, h, "yellow", js, ae, "topRight"],
      //   [x3, y3, w, h, "green", js, ast, "rightBottom"],
      //   [x1, y3, w, h, "#bbb", je, ast, "bottomLeft"],
      //   [x1, y1, w, h, "#aaa666", je, ae, "leftTop"],
      // ];

      let arr = [
        {
          x: x2,
          y: y1,
          w: w,
          h: h,
          color: "red",
          justify: jc,
          align: ae,
          place: "top",
        },
        {
          x: x2,
          y: y3,
          w: w,
          h: h,
          color: "#888",
          justify: jc,
          align: ast,
          place: "bottom",
        },
        {
          x: x3,
          y: y2,
          w: w,
          h: h,
          color: "blue",
          justify: js,
          align: ac,
          place: "right",
        },
        {
          x: x1,
          y: y2,
          w: w,
          h: h,
          color: "#777",
          justify: je,
          align: ac,
          place: "left",
        },
        {
          x: x3,
          y: y1,
          w: w,
          h: h,
          color: "yellow",
          justify: js,
          align: ae,
          place: "topRight",
        },
        {
          x: x3,
          y: y3,
          w: w,
          h: h,
          color: "green",
          justify: js,
          align: ast,
          place: "rightBottom",
        },
        {
          x: x1,
          y: y3,
          w: w,
          h: h,
          color: "#bbb",
          justify: je,
          align: ast,
          place: "bottomLeft",
        },
        {
          x: x1,
          y: y1,
          w: w,
          h: h,
          color: "#aaa666",
          justify: je,
          align: ae,
          place: "leftTop",
        },
      ];

      const otherNodeArea = [];
      if (nodes) {
        nodes.forEach((n) => {
          const st = n.style,
            x = st.left.replace("px", "") - 0,
            y = st.top.replace("px", "") - 0;
          otherNodeArea.push([x, y, n.clientWidth + x, n.clientHeight + y]);
        });
      }

      let i = -1;
      if (startPos) {
        arr.forEach((d, di) => {
          if (d.place == startPos) {
            i = di;
          }
        });
        if (i > 0) {
          const newArr = [];
          for (let x = i; x < arr.length; x++) {
            newArr.push(arr[x]);
          }
          for (let x = 0; x < i; x++) {
            newArr.push(arr[x]);
          }
          arr = newArr;
        }
      }

      const out = [];

      for (const d of arr) {
        //超出右边界
        if (d.x + d.w > bound.w - 20) {
          continue;
        }
        //超出下边界
        if (d.y + d.h > bound.h - 20) {
          // console.log("超出下边界");
          continue;
        }

        //超出左边
        if (d.x < bound.x) {
          // console.log("超出左边");
          continue;
        }

        //超出上面
        if (d.y < bound.y) {
          // console.log(d[1], bound[1], "超出上面", cy, h);
          continue;
        }

        if (otherNodeArea.length > 0) {
          let ct = false;
          for (const n of otherNodeArea) {
            if (d.x > n.x && d.x + d.w < n.x + n.w) {
              ct = true;
              break;
            }

            if (d.y > n.y && d.y + d.h < n.y + n.h) {
              ct = true;
              break;
            }
          }
          if (ct) {
            continue;
          }
        }
        // if (d[1] < 5) {
        //   d[1] = 5;
        // }
        out.push(d);
      }

      if (parent.selectAll(".yyy")) {
        parent.selectAll(".yyy").remove();
      }

      // 显示测试;
      // out.forEach((d) => {
      //   parent
      //     .append("div")
      //     .attr("class", "yyy")
      //     .style("position", "absolute")
      //     .style("left", d.x + "px")
      //     .style("top", d.y + "px")
      //     .style("width", d.w + "px")
      //     .style("height", d.h + "px")
      //     .style("border", "2px solid " + d.color)
      //     .style("display", "flex")
      //     .style("justify-content", d.justify)
      //     .style("align-items", d.align)
      //     .html("ddddddd");
      // });

      // if (out.length > 0) {
      //   const d = out[0];
      //    parent
      //     .append("div")
      //     .attr("class", "yyy")
      //     .style("position", "absolute")
      //     .style("left", d[0] + "px")
      //     .style("top", d[1] + "px")
      //     .style("width", d[2] + "px")
      //     .style("height", d[3] + "px")
      //     .style("border", "2px solid " + d[4])
      //     .style("display", "flex")
      //     .style("justify-content", d[5])
      //     .style("align-items", d[6])
      //     .html("dddddd");
      // }

      if (out.length > 0) {
        return out[0];
      } else {
        if (i > -1) {
          return arr[i];
        }
        return arr[0];
      }
    },

    checkDragBox() {
      return;
      const list = this.getDragBox();
      if (list.length > 0) {
        if (list.filter((d) => d._drag.status == "show").length > 0) {
          this.$store.commit("dragbox-ausblenden", true);
          this.$store.commit("dragbox-einblenden", false);
        } else {
          this.$store.commit("dragbox-ausblenden", false);
          this.$store.commit("dragbox-einblenden", true);
        }
      } else {
        this.$store.commit("dragbox-ausblenden", false);
        this.$store.commit("dragbox-einblenden", false);
      }
    },

    getDragBox() {
      const out = [];
      for (const tl of this.timelineList) {
        for (const d of tl.data) {
          if (d._drag && d._drag.status != "close") {
            out.push(d);
          }
        }
      }
      return out;
    },

    hiddenDateRect(b) {
      this.mainContainer.selectAll(".g-date-image").classed("g-hidden", b);
    },
    hiddenDragBox(d, status, b) {
      d._drag.status = status;
      d._drag.line.classed("g-display-none", b);
      d._drag.circle.classed("g-display-none", b);
      d._drag.box.classed("g-display-none", b);
    },

    openDragBox({ data, event, _dragOption }) {
      const dd = data;
      const vue = this;

      if (_dragOption) {
        dd._drag = _dragOption;
      } else {
        if (dd._drag) {
          vue.hiddenDragBox(dd, "show", false);
          vue.checkDragBox();
          return;
        }
        let pos = vue.autoLabelPlacement({
          cx: event.clientX,
          cy: dd.y,
          w: 250,
          h: 250,
          startPos: "rightBottom",
          parent: vue.svgContainer,
          bound: {
            x: 0,
            y: 0,
            w: vue.svgContainer.node().clientWidth,
            h: vue.svgContainer.node().clientHeight,
          },
          nodes: vue.$el.querySelectorAll(".g-drag-wrapper"),
        });

        dd._drag = {
          x: 0,
          y: 0,
          left: pos.x,
          top: pos.y,
          distX: pos.x - dd.x + 250 / 2,
          distY: pos.y - dd.y,
          collapse: true,
          status: "show",
        };
      }

      const tlClass = dd.tl;

      //add drag line
      dd._drag.line = vue.mainContainer
        .selectAll("newLine")
        .data([dd])
        .enter()
        .append("line")
        .attr("class", "g-drag-line " + tlClass);

      dd._drag.circle = vue.mainContainer
        .selectAll("newLine")
        .data([dd])
        .enter()
        .append("circle")
        .attr("r", 2)
        .attr("class", "g-drag-circle " + tlClass + " " + tlClass + "-stroke");

      // //add drag rect

      const tpl = vue.$el.querySelector("#g-drag-template").cloneNode(true);

      vue.maxZindex++;
      const dragBox = vue.svgContainer
        .selectAll("tmp-div")
        .data([dd])
        .enter()
        .append("div")
        .attr("class", "g-drag-wrapper " + tlClass)
        .style("z-index", vue.maxZindex)
        .html(tpl.innerHTML)
        .style("left", dd._drag.left + "px")
        .style("top", dd._drag.top + "px")
        .call(
          d3
            .drag()
            .filter(function (event) {
              return (
                event.target.classList.contains("g-drag-header") ||
                event.target.classList.contains("g-drag-title")
              );
            })
            .on("start", function (event, d) {
              // vue.svgContainer.selectAll(".g-drag-wrapper").style("z-index", 0);
              vue.maxZindex++;
              d3.select(this).style("z-index", vue.maxZindex);
              d._drag.x = event.x;
              d._drag.y = event.y;

              d._drag.left =
                d3.select(this).style("left").replace("px", "") - 0;
              d._drag.top = d3.select(this).style("top").replace("px", "") - 0;
            })
            .on("drag", function (event, d) {
              let x = d._drag.left + event.x - d._drag.x;
              let y = d._drag.top + event.y - d._drag.y;
              if (y < 0) {
                y = 0;
              }
              if (y > vue.height + 60 + 25) {
                y = vue.height + 60 + 25;
              }

              d._drag.distX = x - d.x + 250 / 2;
              d._drag.distY = y - d.y;
              d3.select(this)
                .style("left", x + "px")
                .style("top", y + "px");
              vue.redrawLine();
            })
        );

      dragBox.select(".g-drag-box").classed(tlClass, true);
      dragBox.select(".g-drag-title").html(dd.headerTitel);
      dragBox
        .select(".g-drag-main")
        .html(dd.html)
        .classed("_collapse", dd._drag.collapse);

      dragBox.select("._close").on("click", function (event, d) {
        vue.hiddenDragBox(d, "close", true);
        vue.checkDragBox();
      });

      const dragMainDiv = dragBox.select(".g-drag-main").node();
      //如果有滚动条
      if (dragMainDiv.scrollHeight > dragMainDiv.clientHeight) {
        dragBox.select("._zu").on("click", function (event, d) {
          d._drag.collapse = true;
          dragBox.select("._zu").classed("g-display-none", true);
          dragBox.select("._auf").classed("g-display-none", false);
          dragBox.select(".g-drag-main").classed("_collapse", true);
        });

        dragBox.select("._auf").on("click", function (event, d) {
          d._drag.collapse = false;
          dragBox.select("._auf").classed("g-display-none", true);
          dragBox.select("._zu").classed("g-display-none", false);
          dragBox.select(".g-drag-main").classed("_collapse", false);
        });
      } else {
        dragBox.select("._zu").classed("g-display-none", true);
        dragBox.select("._auf").classed("g-display-none", true);
      }
      dragBox.select(".g-drag-main").classed("_collapse", false);

      dd._drag.box = dragBox;
      if (_dragOption) {
        dragBox
          .style("left", dd._drag.distX + dd.x - 250 / 2 + "px")
          .style("top", dd._drag.distY + dd.y + "px");
      }
      vue.redrawLine();
      vue.checkDragBox();
    },

    redrawLine() {
      const vue = this;
      this.mainContainer
        .selectAll(".g-drag-line")
        .attr("x1", function (d) {
          return d.x + d.w / 2;
        })
        .attr("x2", function (d) {
          return d._drag.distX + d.x;
        })
        .attr("y1", function (d) {
          // const h = vue.timelineList.find((tl) => tl.idx == d.tl).rectHeight;
          return d.y + d.h / 2;
        })
        .attr("y2", function (d) {
          return d._drag.distY + d.y + 10;
        });

      this.mainContainer
        .selectAll(".g-drag-circle")
        .attr("cx", function (d) {
          return d.x + d.w / 2;
        })
        .attr("cy", function (d) {
          // const h = vue.timelineList.find((tl) => tl.idx == d.tl).rectHeight;
          return d.y + d.h / 2;
        });
    },

    getTranslate(element) {
      const translate = d3
        .select(element)
        .attr("transform")
        .replace(/[^\.\d\,]/g, "")
        .split(",");
      return [translate[0] - 0, translate[1] - 0];
    },

    brushed(s) {
      const vue = this;
      const { xScale, xScaleYear, zoom, xScale2, width, setGridLine } = vue;
      // const s = event.selection || xScale2.range();
      const ds = s.map(xScale2.invert, xScale2);
      xScale.domain(ds);
      xScaleYear.domain(ds);
      vue.redrawMainDate();

      setGridLine(ds);

      // vue.zoomRect.call(
      vue.mainContainer.call(
        zoom.transform,
        d3.zoomIdentity.scale(width / (s[1] - s[0])).translate(-s[0], 0)
      );
      vue.dateSelection = [ds[0], ds[1]];

      vue.setBrushText();
    },

    setGridLine(ds) {
      this.timelineList.forEach((tl) => {
        if (!tl.xAxisContainer) {
          return;
        }

        tl.gridScale.domain(ds);
        tl.xAxisContainer.call(tl.xAxis);
        tl.gridContainer.call(tl.gridAxis);
        //坐标标签改颜色
        tl.xAxisContainer.selectAll("text").style("color", function (t) {
          if (t.getMonth() == 0 && t.getDate() == 1) {
            return "black";
          }
          return tl.colorDark;
        });

        const allLine = tl.gridContainer.selectAll("line");
        //检测是否全是年份
        let allYear = true;
        let allYear10 = true;
        allLine.each((t) => {
          // console.log(t, t.getMonth(), t.getDate());
          if (t.getMonth() != 0 || t.getDate() != 1) {
            allYear = false;
            return;
          }
          if (t.getYear() % 10 != 0) {
            allYear10 = false;
          }
        });

        // 全是10年
        if (allYear10) {
          allLine.style("stroke-opacity", function (t) {
            if (t.getYear() % 100 == 0) {
              return 1;
            }
            return 0.4;
          });
        } else if (allYear) {
          // 全是年
          allLine.style("stroke-opacity", function (t) {
            if (t.getYear() % 10 == 0) {
              return 1;
            }
            return 0.4;
          });
        } else {
          //有年有月
          allLine.style("stroke-opacity", function (t) {
            if (t.getMonth() == 0 && t.getDate() == 1) {
              return 1;
            }
            return 0.4;
          });
        }
      });
    },

    zoomed(event) {
      if (!event.sourceEvent && !this.clickZoomBtn) return; // ignore zoom-by-brush
      const vue = this;
      const {
        xScale,
        xScaleYear,
        xScale2,
        brushContainer,
        brush,
        timelineList,
        setGridLine,
      } = vue;
      //windows resize 之后, zoom 有问题
      const t = event.transform;
      vue.zoomVal = t.k;

      const ds = t.rescaleX(xScale2).domain();
      xScale.domain(ds);
      xScaleYear.domain(ds);

      setGridLine(ds);

      const extent = xScale.range().map(t.invertX, t);
      brushContainer.select(".brush").call(brush.move, extent);
      vue.dateSelection = [ds[0], ds[1]];
      vue.redrawMainDate();
      vue.setBrushText();
      vue.transform = t;
    },

    redrawMainDate() {
      const {
        mainContainer,
        timelineRectMinWidth,
        xScale,
        timelineList,
      } = this;
      // let onDayWidth =
      //   (xScale(moment("2000-01-02")) - xScale(moment("2000-01-01"))) / 2;

      timelineList.forEach((tl) => {
        const tmpLayers = {};
        const tmpData = [];
        // tl.data.forEach((d) => {
        //   tmpData.push(d);
        // });
        // tmpData
        //   .sort((a, b) => {
        //     return a.dateBis - b.dateVon;
        //   })
        tl.data.forEach((d) => {
          let x = xScale(d.dateVon);
          let w = xScale(d.dateBis) - x;
          if (w < timelineRectMinWidth) {
            x = x - (timelineRectMinWidth - w) / 2;
            w = timelineRectMinWidth;
          }
          d.x = x;
          d.overlay = false;
          // if (d.oneDay) {
          //   d.w = onDayWidth;
          //   console.log(onDayWidth)
          // } else {
          //   d.w = w;
          // }
          d.w = w;
          const layerIdx = "lay-" + d.layer;
          if (!tmpLayers[tmpLayers]) {
            tmpLayers[tmpLayers] = [];
          }
          let hastInsection = false;
          for (const d0 of tmpLayers[tmpLayers]) {
            const x0 = d0.x;
            if (
              d.layer == d0.layer &&
              ((x > x0 && x < x0 + 24) || (x < x0 && x + 24 > x0))
            ) {
              // d.w = 0;

              d.overlay = true;
              hastInsection = true;
              break;
            }
          }
          if (!hastInsection) {
            tmpLayers[tmpLayers].push(d);
          }
          // const w = (d.w = xScale(d.dateBis) - x);
          // d.w = d.w < 0.7 ? 0 : d.w;
        });
      });

      mainContainer
        .selectAll(".g-date-rect")
        .transition()
        .duration(this.timelineDuration)
        .attr("transform", function (d) {
          return "translate(" + d.x + "," + d.y + ")";
        })
        .attr("width", function (d) {
          return d.w;
        });

      mainContainer
        .selectAll(".g-date-image")
        .attr("transform", function (d) {
          return "translate(" + d.x + "," + d.y + ")";
        })
        .attr("x", function (d) {
          return d.w / 2 - 14;
        })
        .classed("g-display-none", function (d) {
          // return d.w <= 0;
          return d.overlay;
        });

      d3.select(this.$el)
        .selectAll(".g-drag-wrapper")
        .style("left", function (d) {
          return d.x + d._drag.distX - 250 / 2 + "px";
        });

      d3.select(this.$el)
        .selectAll(".g-drag-wrapper")
        .style("top", function (d) {
          return d.y + d._drag.distY + "px";
        });

      this.redrawLine();
    },

    //每次resize都重绘
    redrawBrushCanvas() {
      const vue = this;
      const {
        brushMarginBottom,
        brushHeight,
        brushMinWidth,
        timelineList,
        brushPadding,
        brushLayerSpacing,
        brushContainer,
        timelineRectMaxHeight,
        xScale2,
        width,
      } = vue;

      //去除padding brush 实际显示区域的高度
      const brushDrawArea =
        brushHeight - brushPadding * timelineList.length * 2;
      //每一层brush layer 获得的高度
      const brushLayerHeight = brushDrawArea / vue.allTimelineLayerCount;
      //计算brush每个layer rect的高度
      let rectHeight =
        brushLayerHeight - brushLayerSpacing < 1
          ? 1
          : brushLayerHeight - brushLayerSpacing;

      if (rectHeight > timelineRectMaxHeight) {
        rectHeight = timelineRectMaxHeight;
      }
      const backgroundContainer = brushContainer.selectAll(
        ".brush-background-container"
      );
      backgroundContainer.selectAll("rect").data([]).exit().remove();
      let lastLayerY2 = 0;
      timelineList.forEach((tl) => {
        tl.y2 = lastLayerY2;
        tl.h2 = brushPadding * 2 + brushLayerHeight * tl.layerCount;
        lastLayerY2 += tl.h2;
        backgroundContainer
          .append("rect")
          .attr("x", 0)
          .attr("y", tl.y2)
          .attr("width", width)
          .attr("height", tl.h2 - brushMarginBottom)
          .attr(
            "class",
            [tl.class, "_background", "brush-background"].join(" ")
          );
      });
      const canvas = this.brushFoCanvas.node();
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);

      timelineList.forEach((tl) => {
        context.fillStyle = tl.color;
        const tly2 = tl.y2 + brushPadding;
        tl.data.forEach((d) => {
          const x2 = xScale2(d.dateVon);
          let w2 = xScale2(d.dateBis) - x2;
          w2 = w2 < brushMinWidth ? brushMinWidth : w2;
          context.fillRect(
            x2,
            tly2 + d.layer * brushLayerHeight,
            w2,
            rectHeight
          );
        });
      });
    },

    setBrushText() {
      const vue = this;
      const xScale2 = this.xScale2;
      const ds = vue.dateSelection;
      const von = ds[0];
      const bis = ds[1];
      const vonStr = moment(von).format(dateFormat);
      const bisStr = moment(bis).format(dateFormat);
      const xVon = xScale2(von);
      const xBis = xScale2(bis);
      const vonArr = vonStr.split("-");
      const bisArr = bisStr.split("-");

      const fromWarpper = this.datePickerFromWrapper;
      const toWarpper = this.datePickerToWrapper;

      fromWarpper.querySelector("._year").innerHTML = vonArr[0];
      fromWarpper.querySelector("._month_day").innerHTML =
        "-" + vonArr[1] + "-" + vonArr[2];

      toWarpper.querySelector("._year").innerHTML = bisArr[0];
      toWarpper.querySelector("._month_day").innerHTML =
        "-" + bisArr[1] + "-" + bisArr[2];

      //set x koordination
      const textLange = fromWarpper.clientWidth;

      let x1 = xVon - textLange + 5;
      let x2 = xBis - 11 / 2 + 2;
      if (x1 < -5) {
        x1 = -5;
        if (x1 + textLange > x2) {
          x2 = x1 + textLange;
        }
      }
      if (x2 > this.width - textLange - 5) {
        x2 = this.width - textLange - 5;
        if (x1 + textLange > x2) {
          x1 = x2 - textLange;
        }
      }

      fromWarpper.style.left = x1 + "px";
      toWarpper.style.left = x2 + "px";
    },
  },
};
</script>

<style lang="scss">
$tl-0-dark: #005ca9;
$tl-0-light: #5585c4;
$tl-0-bg: #e9ecf8;
$tl-0-rect: #a4b7df;

$tl-1-dark: #006d78;
$tl-1-light: #22929d;
$tl-1-bg: #e3eff0;
$tl-1-rect: #91bfc6;

$tl-2-dark: #492a72;
$tl-2-light: #765e97;
$tl-2-bg: #e8e5f1;
$tl-2-rect: #765e97;

.tl-0 {
  &._background {
    fill: $tl-0-bg;
  }

  &.g-drag-box {
    border: 1px solid $tl-0-dark;
    .g-drag-header {
      background-color: $tl-0-dark;
    }
  }

  &.g-drag-line {
    stroke: $tl-0-dark;
  }

  .g-date-rect {
    fill: $tl-0-rect;
    &.unclear_beforeAfter {
      fill: url(#tl-0-beforeAfter);
    }
    &.unclear_before {
      fill: url(#tl-0-before);
    }
    &.unclear_after {
      fill: url(#tl-0-after);
    }
  }

  &.stop-light {
    stop-color: $tl-0-rect;
    stop-opacity: 0.2;
  }
  &.stop-dark {
    stop-color: $tl-0-rect;
    stop-opacity: 1;
  }

  .tl-toolbar {
    ._label-bg {
      fill: $tl-0-light;
    }
  }
}

.tl-1 {
  &._background {
    fill: $tl-1-bg;
  }

  &.g-drag-box {
    border: 1px solid $tl-1-dark;
    .g-drag-header {
      background-color: $tl-1-dark;
    }
  }

  &.g-drag-line {
    stroke: $tl-1-dark;
  }

  .g-date-rect {
    fill: $tl-1-rect;
    &.unclear_beforeAfter {
      fill: url(#tl-1-beforeAfter);
    }
    &.unclear_before {
      fill: url(#tl-1-before);
    }
    &.unclear_after {
      fill: url(#tl-1-after);
    }
  }

  &.stop-light {
    stop-color: $tl-1-rect;
    stop-opacity: 0.2;
  }
  &.stop-dark {
    stop-color: $tl-1-rect;
    stop-opacity: 1;
  }

  .tl-toolbar {
    ._label-bg {
      fill: $tl-1-light;
    }
  }
}

.tl-2 {
  &._background {
    fill: $tl-2-bg;
  }

  &.g-drag-box {
    border: 1px solid $tl-2-dark;
    .g-drag-header {
      background-color: $tl-2-dark;
    }
  }

  &.g-drag-line {
    stroke: $tl-2-dark;
  }

  .g-date-rect {
    fill: $tl-2-rect;
    &.unclear_beforeAfter {
      fill: url(#tl-2-beforeAfter);
    }
    &.unclear_before {
      fill: url(#tl-2-before);
    }
    &.unclear_after {
      fill: url(#tl-2-after);
    }
  }

  &.stop-light {
    stop-color: $tl-2-rect;
    stop-opacity: 0.2;
  }
  &.stop-dark {
    stop-color: $tl-2-rect;
    stop-opacity: 1;
  }
  .tl-toolbar {
    ._label-bg {
      fill: $tl-2-light;
    }
  }
}

.g-timeline__svg-container {
  // margin: 0 20px 20px 20px;
  flex: 1;
  position: relative;
  overflow: hidden;
}
.noselet {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.g-drag-line {
  stroke-width: 1;
}

.g-hidden {
  visibility: hidden;
}

.brush-dateLine-g {
  rect {
    fill: none;
    &.active {
      fill: #000;
    }
  }
  line {
    &.active {
      stroke: red;
    }
  }

  text {
    @extend .noselet;
    font-size: 10pt;
    &.active {
      fill: #fff;
    }
  }
}

.g-date-text {
  font-size: 8pt;
}

.zoom {
  cursor: move;
  fill: none;
  pointer-events: all;
  cursor: default;
}

.brushContainer rect.overlay {
  pointer-events: none;
}

.brushContainer rect.selection {
  fill: #61b1b9;
}

.axis,
.g-brush-datetext {
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.g-brush-datetext {
  font-size: 10pt;
}

.g-info-wrapper {
  position: absolute;
  z-index: 20000;
  width: 250px;
  height: 400px;
  overflow: hidden;
  // overflow: auto;
  // transition: all 0.3s;
  color: #fff;
  display: flex;
  display: -webkit-flex;
  background-color: transparent;
  font-size: 12px;
  pointer-events: none;
  border-radius: 5px;
  .g-info-content {
    border-radius: 5px;
    // background-color: rgba(66, 64, 64, 1);
    background-color: grey;
    a {
      color: #fff;
    }
    border: 1px solid #fff;
    -moz-box-shadow: 0px 3px 8px #222;
    -webkit-box-shadow: 0px 3px 8px #222;
    box-shadow: 0px 3px 8px #222;
  }
}

.g-menu-wrapper {
  position: absolute;
  z-index: 10;
  max-width: 400px;
  padding: 10px;
  background-color: #fff;
  transition: all 0.3s;
  color: #000;
  border-radius: 5px;
  text-align: left;
}

.g-timeline-checkbox {
  padding: 0 5px;
  margin-right: 10px;
  border: 2px solid #ddd;
  cursor: pointer;
  &:hover {
    border: 1px solid #aaa;
  }
}

.tl-toolbar {
  ._btn-image {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  ._label {
    @extend .noselet;
    font-size: 10px;
    fill: #fff;
  }
}

.tl-grid {
  line {
    stroke-opacity: 1;
    stroke: #999;
    // stroke-width: 0.8;
  }
  path {
    opacity: 0;
  }
}

.g-drag-wrapper {
  width: 250px;
  max-height: 250px;
  position: absolute;
  -moz-box-shadow: 0px 3px 5px #888;
  -webkit-box-shadow: 0px 3px 5px #888;
  box-shadow: 0px 3px 5px #888;
  border-radius: 5px;
  .g-drag-box {
    background-color: #fff;
    border-radius: 5px;
    .g-drag-header {
      cursor: move;
      height: 20px;
      width: 100%;
      padding: 0 2px 0 10px;
      * {
        color: #fff;
      }
    }
    font-size: 12px;

    .g-drag-title {
      // cursor: move;
      &:hover {
        opacity: 0.9;
      }
    }

    ._box-img {
      cursor: pointer;
      margin-left: 5px;
      width: 16px;
      height: 16px;
      &:hover {
        opacity: 0.9;
      }
    }

    .g-drag-main {
      padding: 2px 10px;
      overflow-y: auto;
      max-height: 250px;
    }

    ._collapse {
      max-height: 6em;
      // overflow: hidden;
      // padding: 0;
      transition: max-height 0.2s;
      // transition: padding 0.2s;
    }
  }
}

.g-display-none {
  display: none;
}

.weight-bold {
  font-weight: bold;
}

.g-timeline_zoombtn-wrapper {
  position: absolute;
  z-index: 1000;
  right: 2px;
  width: 18px;
  left: -1000px;
  // height: 48px;

  .g-timeline_zoombtn {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 1px;
    cursor: pointer;
    &:active:not(.zoombtn-disable) {
      opacity: 1;
    }

    &:hover {
      opacity: 0.8;
    }

    &.zoombtn-disable {
      opacity: 0.3;
    }
  }
}

.g-date-rect,
.g-date-image {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}

.vd-picker__input {
  input {
    display: none;
  }
}
.main-container {
  pointer-events: all;
}

.datepicker-from-wrapper,
.datepicker-to-wrapper {
  width: auto;
  position: absolute;
  left: -100px;
  z-index: 1;
  padding: 0;
  margin: 0;
  font-size: 12px;
  ._year {
    font-weight: 1000;
    margin-top: 4px;
    margin-left: -5px;
  }
  ._month_day {
    margin-top: 4px;
  }
}
// .tick{
// text{
// stroke-width:0.2;
// stroke: #000;
// }
// }
</style>
